import React, { useRef } from 'react';
import { Button, Row } from 'reactstrap';
import { faArrowLeft, faFileCsv, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from 'react-csv';
import moment from 'moment';

//Context
import { useAuth } from '../../../../context/auth';

//Components
import CardRelatorio from '../components/CardRelatorio';

//Helpers
import mascaras from '../../../../helpers/mascaras';

//Estilo da pagina de impressão
const pageStyle = `
@media print {
  @page{
    size: A4;
    margin: 0.5rem;
  }

  body { 
    -webkit-print-color-adjust: exact; 
  } 

  .relatorio {
    width: 100vw !important;
    display:flex !important;
    flex-direction: column !important;
    padding: 0px 15px !important;
  }

  div.header{
    display:table-header-group;
  }

  div.body{
    display:table-row-group;
  }

  .noPrint{
    display: none;
  }
}
`;

function RelatorioInfracoes({ infracoesRelatorio = [], filtros, handleVoltar }) {
  const { session, logoSistema, logoSecretaria, logoPrefeitura } = useAuth();

  //Referencia do relatorio para download do csv
  const exportRef = useRef(null);

  //Referencia para o componente de impressão
  const ref = useRef(null);

  //headers da exportação do csv
  const headersExport = [
    { key: "tipoFiscalizacao", label: "TIPO DE FISCALIZAÇÃO" },
    { key: "infracao", label: "INFRAÇÃO" },
    { key: "numeroInfracao", label: "NÚMERO DA INFRAÇÃO" },
    { key: "nome", label: "NOME DO INFRATOR" },
    { key: "cpfcnpj", label: "CPF/CNPJ DO INFRATOR" },
    { key: "endereco", label: "ENDEREÇO" },
    { key: "dataInfracao", label: "DATA DA INFRAÇÃO" },
    { key: "dataLavratura", label: "DATA DA LAVRATURA" },
    { key: "usuario", label: "USUÁRIO" },
    { key: "numeroProcesso", label: "PROCESSO" },
    { key: "situacao", label: "SITUAÇÃO" },
    { key: "statusBoleto", label: "STATUS DO BOLETO" },
    { key: "statusDividaAtiva", label: "STATUS DA DÍVIDA ATIVA" },
    { key: "valorUltimoBoleto", label: "VALOR BOLETO" },
  ];


  const headersInfracoes = [
    { objectValue: "tipoFiscalizacao", value: "TIPO DE FISCALIZAÇÃO", col: "12" },
    { objectValue: "infracao", value: "INFRAÇÃO", col: "12" },
    { objectValue: "numeroInfracao", value: "NÚMERO DA INFRAÇÃO", col: "12" },
    { objectValue: "nome", value: "NOME DO INFRATOR", col: "12" },
    { objectValue: "cpfcnpj", value: "CPF/CNPJ DO INFRATOR", col: "12" },
    { objectValue: "endereco", value: "ENDEREÇO", col: "12" },
    { objectValue: "dataInfracao", value: "DATA DA INFRAÇÃO", col: "12" },
    { objectValue: "dataLavratura", value: "DATA DA LAVRATURA", col: "6" },
    { objectValue: "usuario", value: "USUÁRIO", col: "6" },
    { objectValue: "numeroProcesso", value: "PROCESSO", col: "6" },
    { objectValue: "situacao", value: "SITUAÇÃO", col: "6" },
    { objectValue: "statusBoleto", value: "STATUS DO BOLETO", col: "6" },
    { objectValue: "statusDividaAtiva", value: "STATUS DA DÍVIDA ATIVA", col: "6" },
    { objectValue: "valorUltimoBoleto", value: "VALOR DO ÚLTIMO BOLETO", col: "6" },
  ];


  //Função assionada assim que o botão de imprimir pdf é clicado
  const handlePrint = useReactToPrint({
    content: () => ref.current,
    documentTitle: "RelatorioInfracoes",
    pageStyle: pageStyle
  });

  return <>
    <div className='shadowFicha mainContainerFicha p-4'>
      <div className='d-flex align-items-center justify-content-between'>
        <Button color='secondary' className='text-white' onClick={handleVoltar}>
          <FontAwesomeIcon icon={faArrowLeft} />
          <span className='px-2'> Voltar </span>
        </Button>
        <div className='d-flex gap-2'>
          <Button color='danger' onClick={handlePrint}>
            <FontAwesomeIcon icon={faFilePdf} /> Imprimir
          </Button>
          <Button color='success' onClick={() => exportRef.current.link.click()}>
            <FontAwesomeIcon icon={faFileCsv} />
            <span className='px-2'> CSV </span>
          </Button>
        </div>
      </div>

      <CSVLink
        separator={";"}
        data={infracoesRelatorio}
        headers={headersExport}
        filename="Relatorio_Infracoes.csv"
        target="_blank"
        ref={exportRef}
      />

      <div className="mt-4 relatorio w-100" ref={ref}>
        <div className="print m-2 d-flex align-items-center justify-content-between">
          <p>Emitido por: {session.nome}</p>
          <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
        </div>

        <div className='d-flex justify-content-between align-items-center w-100'>
          {logoSistema &&
            <div>
              <img src={logoSistema} width={180} alt="logo do sistema" />
            </div>
          }
          <div>
            {logoSecretaria && <img src={logoSecretaria} className='mt-3' width={140} alt="logo do sistema" />}
            {logoSecretaria && <img src={logoPrefeitura} width={120} alt="logo da prefeitura" />}
          </div>
        </div>

        <div className="header">
          <h5 style={{ color: "#666" }}>Relatório de Infrações</h5>
          <Row>
            <div className='col-4'>
              <p><span className="fw-bold">Período:</span> {moment(filtros.dataInfracaoInicial).format("DD/MM/YYYY")} à {moment(filtros.dataInfracaoFinal).format("DD/MM/YYYY")}</p>
            </div>
            <div className='col-4'>
              <p><span className="fw-bold">Período de Datas:</span> {filtros.periodoDatas}</p>
            </div>
            <div className='col-4'>
              <p><span className="fw-bold">Tipo de Fiscalização:</span> {filtros.tipoFiscalizacao_Descricao}</p>
            </div>
            {!!filtros.infracao_nome &&
              <div className='col-4'>
                <p><span className="fw-bold">Infração:</span> {filtros.infracao_nome}</p>
              </div>
            }
            {!!filtros.nomeInfrator &&
              <div className='col-4'>
                <p><span className="fw-bold">Nome do Infrator:</span> {filtros.nomeInfrator}</p>
              </div>
            }
            {!!filtros.cpfcnpj &&
              <div className='col-4'>
                <p><span className="fw-bold">CPF/CNPJ:</span> {mascaras.cpfcnpjMask(filtros.cpfcnpj)}</p>
              </div>
            }
            {!!filtros.numeroInfracao &&
              <div className='col-4'>
                <p><span className="fw-bold">Número da Infração:</span> {filtros.numeroInfracao}</p>
              </div>
            }
            {!!filtros.situacao &&
              <div className='col-4'>
                <p><span className="fw-bold">Situação:</span> {filtros.situacao}</p>
              </div>
            }
            {!!filtros.usuario_nome &&
              <div className='col-4'>
                <p><span className="fw-bold">Usuário Fiscalização:</span> {filtros.usuario_nome}</p>
              </div>
            }
          </Row>
        </div>

        <div
          className='body'
          style={{ color: "#666" }}
        >
          <h5 className='rounded-3 bg-secondary text-light p-2'>Lista de Infrações</h5>
          <CardRelatorio
            headers={headersInfracoes}
            items={infracoesRelatorio}
          />
        </div>
      </div >
    </div>
  </>;
}

export default RelatorioInfracoes;